import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import auth from './auth';
import course from './course';
import history from '../../history';

const authConfig = {
  key: 'auth',
  storage,
  blacklist: ['isProceeding', 'error'],
};

const rootReducer = combineReducers({
  auth: persistReducer(authConfig, auth),
  course,
  router: connectRouter(history),
});

export default rootReducer;
